import React from "react";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  PopoverArrow,
  useDisclosure,
  HStack,
  Text,
  Stack,
  SimpleGrid,
  Heading,
  StackDivider,
  Box,
  useBreakpoint,
  Flex,
  Button,
} from "@chakra-ui/react";
import { BiChevronDown } from "react-icons/bi";

export default function CommonHeaderCategory({ name, structured, linksList }) {
  const { isOpen, onToggle, onClose } = useDisclosure();
  const breakpoint = useBreakpoint({ ssr: false });
  if (breakpoint !== "2xl") {
    return (

    <HStack
      cursor="pointer"
      display={{ base:"flex","2xl": "none" }}
      w="max-content"
      flexWrap="nowrap"
      pr={2}
    >
      <Text w="max-content" color="#707070" fontSize="12px" fontWeight="medium">
        {name}
      </Text>
      <BiChevronDown size="15px" />
    </HStack>

    )
  }
  return (
    <>
      <Popover
        returnFocusOnClose={false}
        isOpen={isOpen}
        onClose={onClose}
        placement="bottom-start"
        closeOnBlur={true}
        styleConfig={{ display: { base: "none", "2xl": "block" } }}
      >
        <PopoverTrigger display={{ base: "none", "2xl": "block" }}>
          <HStack cursor="pointer" onClick={onToggle}>
            <Text
              w="max-content"
              color="#707070"
              fontSize="15px"
              fontWeight="medium"
            >
              {name}
            </Text>
            <BiChevronDown size="18px" />
          </HStack>
        </PopoverTrigger>
        <PopoverContent width="max-content">
          <PopoverArrow />

          <PopoverBody>
            {structured ? (
              <Stack p={8} width="max-content">
                <SimpleGrid gap={12} columns={linksList.length}>
                  {linksList.map((linksListItem, index) => {
                    return (
                      <Stack
                        key={index}
                        gap={5}
                        borderRight={
                          linksList.length - 1 === index ? "0px" : "2px"
                        }
                        borderColor="#c5c5c5"
                        pr={linksList.length - 1 === index ? 0 : 10}
                        divider={<StackDivider color="#c5c5c5" border="1px" />}
                      >
                        {linksListItem.map((item) => {
                          return (
                            <Stack
                              key={item.title}
                              gap={2}
                              height={item.list.length > 5 ? "300px" : "220px"}
                            >
                              <Heading fontSize="22px" fontWeight="semibold">
                                {item.title}
                              </Heading>
                              <Stack>
                                {item.list.map((listData) => {
                                  return (
                                    <Text
                                      key={listData.label}
                                      cursor="pointer"
                                      fontSize="18px"
                                      color="#707070"
                                      fontWeight="medium"
                                    >
                                      {listData.label}
                                    </Text>
                                  );
                                })}
                              </Stack>
                            </Stack>
                          );
                        })}
                      </Stack>
                    );
                  })}
                </SimpleGrid>
              </Stack>
            ) : (
              <Stack p={8} width="max-content">
                <SimpleGrid gap={12} columns={linksList.length}>
                  {linksList.map((linksListItem, index) => {
                    return (
                      <Stack
                        key={index}
                        gap={1}
                        borderRight={
                          linksList.length - 1 === index ? "0px" : "4px"
                        }
                        borderColor="#c5c5c5"
                        pr={linksList.length - 1 === index ? 0 : 10}
                      >
                        {linksListItem.map((listData) => {
                          return (
                            <Text
                              key={listData.label}
                              cursor="pointer"
                              fontSize="18px"
                              color="#707070"
                              fontWeight="medium"
                            >
                              {listData.label}
                            </Text>
                          );
                        })}
                      </Stack>
                    );
                  })}
                </SimpleGrid>
              </Stack>
            )}
          </PopoverBody>
        </PopoverContent>
      </Popover>
    </>
  );
}
